export default "__VITE_ASSET__52636494__"